export enum UserType {
  SHIPPER = 1,
  PARTNER = 2,
  DRIVER = 3,
  INTERNAL = 4,
  DEMAND_ADDA = 5,
}
